import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

import PlusIcon from "assets/icons/plus.svg?react";

import {
  MAX_PARKINGS_LIMIT,
  MAX_APARTMENTS_LIMIT,
  CALCULATOR_OBJECT_TYPES,
  CALCULATOR_PARKING_TYPES,
} from "constants/calculator";

import { Button } from "shared/ui/components/Button";
import { Popover } from "shared/ui/components/Popover";
import { Typography } from "shared/ui/components/Typography";

import styles from "./AddObjectButton.module.scss";

const AddObjectButton = ({
  isMobile = false,
  onAddObjectClick,
}: {
  isMobile?: boolean;
  onAddObjectClick: (type: string) => void;
}) => {
  const { t } = useTranslation();
  const { values } = useFormikContext<any>();

  const isApartment = values.apartments.length < MAX_APARTMENTS_LIMIT;
  const isParking = values.parkings.length < MAX_PARKINGS_LIMIT;

  return (
    <Popover
      placement={isMobile ? "bottom-start" : "bottom-end"}
      yOffset={isMobile ? 0 : 20}
      floatingArrowProps={isMobile ? undefined : { width: 17, height: 10, fill: "#fff" }}
      triggerClassName={styles.triggerWrapper}
      triggerElement={() => (
        <div className={styles.trigger}>
          <PlusIcon className={styles.triggerIconDesktop} />
          <Button
            className={styles.triggerButton}
            variant="tertiary"
            size="small"
            startIcon={<PlusIcon className={styles.triggerIconMobile} />}
          >
            {t("calculator_form.invest_objects.add_button")}
          </Button>
        </div>
      )}
    >
      <div className={styles.popoverInner}>
        {isApartment && (
          <div
            className={styles.popoverInnerItem}
            onClick={() => onAddObjectClick(CALCULATOR_OBJECT_TYPES.APARTMENT)}
          >
            <Typography variant="bodyM">
              {t("calculator_form.invest_objects.add_apartment")}
            </Typography>
          </div>
        )}
        {isParking && (
          <div
            className={styles.popoverInnerItem}
            onClick={() =>
              onAddObjectClick(CALCULATOR_PARKING_TYPES.PARKING_UNDERGROUND)
            }
          >
            <Typography variant="bodyM">
              {t(
                "calculator_form.invest_objects.add_parking_space_underground"
              )}
            </Typography>
          </div>
        )}
        {isParking && (
          <div
            className={styles.popoverInnerItem}
            onClick={() =>
              onAddObjectClick(CALCULATOR_PARKING_TYPES.PARKING_GARAGE)
            }
          >
            <Typography variant="bodyM">
              {t("calculator_form.invest_objects.add_parking_space_garage")}
            </Typography>
          </div>
        )}
        {isParking && (
          <div
            className={styles.popoverInnerItem}
            onClick={() =>
              onAddObjectClick(CALCULATOR_PARKING_TYPES.PARKING_OUTDOOR)
            }
          >
            <Typography variant="bodyM">
              {t("calculator_form.invest_objects.add_parking_space_outdoor")}
            </Typography>
          </div>
        )}
      </div>
    </Popover>
  );
};

export default AddObjectButton;
